module.exports = __webpack_public_path__ + "static/media/geyueqiang.8c0246f1.png";